import { Colors } from "@brg/ui";
import styled from "styled-components";
import OK from "./assets/OK.svg"

export const TOUWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 22px;
    max-width: min(90vw, 890px);
`

export const TOUTitle = styled.div`
    font-family: Inter;
    margin-bottom: 2px;
    font-size: 42px;
    font-weight: 600;
    line-height: 48px;
    letter-spacing: -0.02em;
    text-align: center;
`

export const TOUTextSection = styled.div`
    font-family: Inter;
    font-size: 15px;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: -0.02em;
    text-align: left;
    color: ${Colors.galBlack61};

    height: 55%;
    overflow-y: scroll;
    display: flex;
    flex-direction: column;
    gap: 16px;

    &::-webkit-scrollbar {
        width: 2px;
    }

    &::-webkit-scrollbar-track {
        background-color: transparent;
    }

    &::-webkit-scrollbar-thumb {
        opacity: 0.47;
        border-radius: 2px;
    }
`

export const TextItem = styled.div`
    width: calc(100% - 16px);
`

export const TOUCheckboxWrapper = styled.div`
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 10px
`

export const TOUCheckboxButton = styled.div<{checked: boolean}>`
    width: 24px;
    height: 24px;
    box-sizing: border-box;
    background-color: ${Colors.gal};
    border: 1px solid ${Colors.galBlack47};
    border-radius: 3px;
    padding: 8px 7px 8px;

    & div {
        display: ${p => p.checked ? "block" : "none"};
    }
`

export const TOUCheckboxLabel = styled.div`
    font-family: Inter;
    font-size: 20px;
    font-weight: 400;
    line-height: 32px;
    letter-spacing: -0.02em;
    text-align: left;
    color: ${Colors.galBlack61};

    & a {
        text-decoration: underline;
        color: ${Colors.galBlack61};

        &:hover {
            color: ${Colors.galBlack47};
        }
    }
`

export const TOUButtons = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 17px;
`

export const TOUCancelButton = styled.button`
    cursor: pointer;
    padding: 12px 61px;
    font-family: Inter;
    font-size: 17px;
    font-weight: 600;
    line-height: 22px;
    letter-spacing: -0.02em;
    text-align: left;
    border: 1px solid ${Colors.galBlack31};
    border-radius: 3px;
`

export const TOUConfirmButton = styled.button`
    cursor: pointer;
    padding: 12px 57.5px;
    font-family: Inter;
    font-size: 17px;
    font-weight: 600;
    line-height: 22px;
    letter-spacing: -0.02em;
    text-align: left;
    color: ${Colors.gal};
    background-color: ${Colors.galBlack100};
    border-radius: 3px;

    &:disabled {
        background-color: ${Colors.galBlack73};
    }
`

export const OKIcon = styled.div`
    width: 10px;
    height: 7px;
    background: url(${OK})
`import { Colors } from "@brg/ui";
import styled from "styled-components";
import OK from "./assets/OK.svg"

export const TOUWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 22px;
    max-width: min(90vw, 890px);
`

export const TOUTitle = styled.div`
    font-family: Inter;
    margin-bottom: 2px;
    font-size: 42px;
    font-weight: 600;
    line-height: 48px;
    letter-spacing: -0.02em;
    text-align: center;
`

export const TOUTextSection = styled.div`
    font-family: Inter;
    font-size: 15px;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: -0.02em;
    text-align: left;
    color: ${Colors.galBlack61};

    height: 55%;
    overflow-y: scroll;
    display: flex;
    flex-direction: column;
    gap: 16px;

    &::-webkit-scrollbar {
        width: 2px;
    }

    &::-webkit-scrollbar-track {
        background-color: transparent;
    }

    &::-webkit-scrollbar-thumb {
        opacity: 0.47;
        border-radius: 2px;
    }
`

export const TextItem = styled.div`
    width: calc(100% - 16px);
`

export const TOUCheckboxWrapper = styled.div`
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 10px
`

export const TOUCheckboxButton = styled.div<{checked: boolean}>`
    width: 24px;
    height: 24px;
    box-sizing: border-box;
    background-color: ${Colors.gal};
    border: 1px solid ${Colors.galBlack47};
    border-radius: 3px;
    padding: 8px 7px 8px;

    & div {
        display: ${p => p.checked ? "block" : "none"};
    }
`

export const TOUCheckboxLabel = styled.div`
    font-family: Inter;
    font-size: 20px;
    font-weight: 400;
    line-height: 32px;
    letter-spacing: -0.02em;
    text-align: left;
    color: ${Colors.galBlack61};

    & a {
        text-decoration: underline;
        color: ${Colors.galBlack61};

        &:hover {
            color: ${Colors.galBlack47};
        }
    }
`

export const TOUButtons = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 17px;
`

export const TOUCancelButton = styled.button`
    cursor: pointer;
    padding: 12px 61px;
    font-family: Inter;
    font-size: 17px;
    font-weight: 600;
    line-height: 22px;
    letter-spacing: -0.02em;
    text-align: left;
    border: 1px solid ${Colors.galBlack31};
    border-radius: 3px;
`

export const TOUConfirmButton = styled.button`
    cursor: pointer;
    padding: 12px 57.5px;
    font-family: Inter;
    font-size: 17px;
    font-weight: 600;
    line-height: 22px;
    letter-spacing: -0.02em;
    text-align: left;
    color: ${Colors.gal};
    background-color: ${Colors.galBlack100};
    border-radius: 3px;

    &:disabled {
        background-color: ${Colors.galBlack73};
    }
`

export const OKIcon = styled.div`
    width: 10px;
    height: 7px;
    background: url(${OK})
`